export default __webpack_public_path__ + "8239f983aa64fa3683ea38f8f7ee0b67.png";